import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CountUp from 'react-countup';
import extend from 'extend';

import ListRow from './list-row';

const styles = {
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chart: {
    flexGrow: 1,
  },
  highchart: {
    display: 'flex',
    justifyContent: 'center',
  },
  list: {
    flexGrow: 2,
    minWidth: '300px',
  },
  row: {
    display: 'flex',
    paddingLeft: '10px',
  },
  value: {
    flexGrow: 1,
    textAlign: 'right',
  },
};

export const colors = ['#882c66', '#066B7F', '#353535', '#00c0ef', '#dd4b39', '#00a65a', '#f39c12'];

class ListWithSumVisualizer extends Component {
  componentDidMount() {
    this.chartRef = React.createRef();
  }

  renderChart = () => {
    const { data, options } = this.props;

    const mainData = data[0][0];


    const series = [{
      innerSize: '80%',
      data: mainData.data.map(elem => ({ name: elem.name, y: elem.y })),
    }];

    const highchartOptions = {
      chart: {
        backgroundColor: '#fefefe',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        width: '250',
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: false,
          colors,
        },
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: `<p><b>{point.y} ${options.unit} </b>({point.percentage:.1f}%)</p>`,
      },
      series,
    };

    extend(true, highchartOptions, options);

    return (
      <div style={styles.chart}>
        <HighchartsReact
          highcharts={Highcharts}
          options={highchartOptions}
          ref={this.chartRef}
          containerProps={{ style: styles.highchart }}
        />
      </div>
    );
  }

  renderList = () => {
    const { data, options } = this.props;

    const mainData = data[0][0];

    const sum = mainData.data.map(d => d.y).reduce((pv, cv) => pv + cv, 0);

    const rows = mainData.data.map((d, i) => (
      <ListRow key={d.name} colors={colors} name={d.name} value={d.y} total={sum} index={i} unit={options.unit} />));

    return (
      <div style={styles.list}>
        <div style={styles.row}>
          <h3>Summe</h3>
          <CountUp
            end={sum}
            suffix={options.unit}
            decimals={2}
            decimal=","
            delay={0}
          >
            {({ countUpRef }) => (
              <h3 style={styles.value}>
                <span ref={countUpRef} />
              </h3>
            )}
          </CountUp>
        </div>
        {rows}
      </div>
    );
  }

  render() {
    return (
      <div style={styles.wrapper}>
        {this.renderChart()}
        {this.renderList()}
      </div>

    );
  }
}

ListWithSumVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
};

ListWithSumVisualizer.defaultProps = {
  data: [],
  options: [],
};

export default ListWithSumVisualizer;
